module.exports = __webpack_public_path__ + "static/google-play-dffd25fb8394300c3b19e0f5b52ec27d.svg";